/**
 * On Course Scoring Reducers
 */
import {
    OCSCORING_ACTION,
    ALL_OCSCORING,
    ADD_OCSCORING,
    FETCH_OCSCORING,
    EDIT_OCSCORING,
    DELETE_OCSCORING,
    FETCH_OCSCORINGCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ocscoringlist:[],
    particularocscoring:[],
    oncscoringchart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case OCSCORING_ACTION:
            return { ...state, loading: true };       

        case ALL_OCSCORING:
            return { ...state, loading: false, ocscoringlist: action.payload };     
            
        case ADD_OCSCORING:
            return { ...state, loading: false };     
         
        case FETCH_OCSCORING:
            return { ...state, loading: false, particularocscoring: action.payload };  
            
        case EDIT_OCSCORING:
            return { ...state, loading: false }; 
            
        case DELETE_OCSCORING:
            return { ...state, loading: false };     

        case FETCH_OCSCORINGCHART:
            return { ...state, loading: false, oncscoringchart: action.payload }; 
        
        default: return { ...state };

     }
 }